<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listservices" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Add Portfolio</span>
      </section>
    </article>
    <h4>Add Portfolio</h4>
    <article class="row">
      <section class="input-field col s6">
        <select class="browser-default"
                v-model="payload.recommendation_type_id"
                :disabled="!$auth.hasRoles('admin')"
        >
          <option v-for="recommendationType of recommendationTypes"
                  :key="recommendationType.id"
                  :value="recommendationType.id"
          >
            {{ recommendationType.name }}
          </option>
        </select>
        <label class="active">Recommendation Type</label>
      </section>
      <section class="input-field col s6">
        <select class="browser-default"
                v-model="payload.portfolio_type_id"
        >
          <option v-for="portfolioType of portfolioTypes"
                  :key="portfolioType.id"
                  :value="portfolioType.id"
          >
            {{ portfolioType.name }}
          </option>
        </select>
        <label class="active">Portfolio Type</label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s4">
        <input id="ticker-admin-add-portfolio-active-date"
               type="text"
               class="datepicker"
               @change="payload.active_date = $event.target.value"
        >
        <label class="active">Active Date</label>
      </section>
      <section class="input-field col s4">
        <input id="ticker-admin-add-portfolio-inactive-date"
               type="text"
               class="datepicker"
               @change="payload.inactive_date = $event.target.value"
        >
        <label class="active">
          Inactive Date
          <span class="grey-text text-lighten-1">(Optional)</span>
        </label>
      </section>
      <section class="input-field col s4">
      <input placeholder="#1 ($USDUSD) US Dollar" type="search" list="currencylist" v-model="defaultCurrencyName" />
        <datalist id="currencylist">
          <option  v-if='currencies.length' v-for="currency of currencies"
                  :key="currency.id"
                  :value="`#${currency.id} (${currency.symbol}) ${currency.name}`"
          >
            {{`#${currency.id} (${currency.symbol}) ${currency.name}`}}
          </option>
        </datalist>
        <label class="active">Currency </label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s6">
        <input type="text"
               placeholder="e.g. Stock Advisor Tom"
               class="validate"
               v-model="payload.name"
        >
        <label class="active">Name</label>
      </section>
      <section class="input-field col s6">
        <input type="text"
               placeholder="e.g. @StockAdvisorTomInclusion"
               class="validate"
               v-model="payload.slug"
        >
        <label class="active">Slug</label>
      </section>
    </article>
    <article class="row">
      <autocomplete
        ref="ref-ticker-admin-add-portfolio-service"
        id="ticker-admin-add-portfolio-service"
        name="Service"
        size="s6"
        watermark="e.g. Stock Advisor"
        :picks="servicePicks"
        @picked="setServiceInfo($event)"
        v-if="servicePicks.length"
      />
      <autocomplete
        v-if="benchmarks.length"
        id="add-portfolio-benchmark-autocomplete"
        name="Benchmark"
        size="s6"
        watermark="e.g. S&P 500"
        :picks="benchmarks.map(b => `#${b.id} (${b.symbol}) ${b.name}`)"
        @picked="payload.benchmark_id = Number($event.slice(1, $event.indexOf(' ')))"
      />
      <!-- ^ TODO: Switch to new Benchmark ID ^ -->
      <section class="input-field col s6" />
    </article>
    <article class="row" v-if="$auth.hasRoles('admin') && payload.portfolio_type_id === 2">
      <section class="input-field col s6">
        <input type="text"
               placeholder="24hr time string (HH:MM:SS), e.g. 16:30:00"
               class="validate"
               v-model="payload.portfolio_update_time"
        >
        <label class="active">Update Time</label>
      </section>
      <autocomplete
        v-if="timezones.length"
        id="add-portfolio-timezone-autocomplete"
        name="Timezone"
        size="s6"
        watermark="e.g. US/Eastern"
        :picks="timezones"
        @picked="payload.timezone = $event"
      />
    </article>
    <article class="row">
      <section class="input-field valign-wrapper col s9">
      <div class="col s3">
        <div class="valign-wrapper">
          <label>
            <input type="checkbox" class="filled-in" v-model="payload.embargo_recs_until_publish" />
            <span>Embargo Recs Until Published</span>
          </label>
        </div>
      </div>
      <div class="col s6 left-align" style="line-height: 1.2em; font-weight: 500; margin-left: 10px; font-size: 14px">
        <p class="red-text">
          Keep box checked if you want your recommendation entry to show up on the online scorecard when the article is published. 
        </p>
        <p class="red-text">
          Uncheck Box if you want the portfolio's recommendation entries to immediately show up on the scorecard. 
        </p>
      </div>
    </section>
      <section class="input-field col s3" v-if="payload.portfolio_type_id === 1">
        <input type="number" step="0.01"
               placeholder="10000.00"
               class="validate"
               v-model="payload.cash_commitment"
        >
        <label class="active">Cash Commitment</label>
      </section>
      <section class="input-field col s3" v-else />
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light right teal accent-4"
               type="submit"
               value="Submit"
               @click.prevent="savePortfolio"
               v-if="$auth.hasRoles('admin')"
        >
        <input class="btn waves-effect waves-light right teal accent-4"
               type="submit"
               value="Request"
               @click.prevent="sendPortfolioRequest"
               v-else
        >
      </section>
    </article>
    <notification-modal ref="ref-notification-modal" :message="notificationMessage" />
  </main>
</template>

<script>
import axios from 'axios';
import Autocomplete from '@/components/Autocomplete.vue';
import NotificationModal from '@/components/NotificationModal.vue';

const defaultPayload = {
  active: true,
  active_date: '',
  analyst_id: 0,
  benchmark_id: 0,
  default_currency_id: '',
  inactive_date: '',
  name: '',
  portfolio_type_id: 2,
  service_id: 0,
  slug: '',
  recommendation_type_id: 1,
  portfolio_update_time: '',
  timezone: '',
  cash_commitment: 0,
  embargo_recs_until_publish: true,
};

export default {
  name: 'TickerAdminAddPortfolio',
  components: { Autocomplete, NotificationModal },
  props: {},
  data() {
    return {
      services: [],
      recommendationTypes: [],
      portfolioTypes: [],
      benchmarks: [],
      currencies: [],
      payload: { ...defaultPayload },
      notificationMessage: '',
      timezones: [],
      defaultCurrencyName: '',
    };
  },
  computed: {
    servicePicks() {
      return this.services.map(service => `#${service.id} ${service.name}${service.product_id ? ` (${service.product_id})` : ''}`);
    },
    defaultCurrencyId() {
      if (this.defaultCurrencyName) {
        return Number(this.defaultCurrencyName.slice(1, this.defaultCurrencyName.indexOf(' ')));
      }
      return 0;
    },
  },
  methods: {
    setServiceInfo($event) {
      this.service_name = $event;
      this.payload.service_id = Number($event.slice(1, $event.indexOf(' ')));
    },
    openNotificationModal() {
      const { modal } = this.$refs['ref-notification-modal'];
      modal.open();
    },
    validateForm(isRequestType) {
      let fieldsToCheck = [
        this.payload.active_date,
        this.payload.analyst_id,
        this.payload.benchmark_id,
        this.defaultCurrencyName,
        this.payload.name,
        this.payload.portfolio_type_id,
        this.payload.slug,
        this.payload.recommendation_type_id,
        this.payload.service_id,
        this.payload.portfolio_update_time,
        this.payload.timezone,
      ];

      if (isRequestType || this.payload.portfolio_type_id !== 2) {
        fieldsToCheck = fieldsToCheck.slice(0, 9);
      }

      return (fieldsToCheck.every(arg => Boolean(arg)));
    },
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/services/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/recommendation_types/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio_types/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/benchmarks/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/currencies/`),
      ];
      const [servicesResp, recommendationTypesResp, portfolioTypesResp, benchmarksResp, currenciesResp] = await Promise.all(promises);
      [this.services, this.recommendationTypes, this.portfolioTypes, this.benchmarks, this.currencies] =
      [servicesResp.data, recommendationTypesResp.data, portfolioTypesResp.data, benchmarksResp.data, currenciesResp.data];
    },
    async fetchPortfolioTimezones() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio_timezones/`);
      this.timezones = data;
    },
    initDatepicker() {
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
    async savePortfolio() {
      this.payload.analyst_id = this.$auth.user.pk;
      this.payload.name = this.payload.name.trim();
      this.payload.slug = this.payload.slug.trim();
      this.payload.active = !this.payload.inactive_date;
      this.payload.inactive_date = this.payload.inactive_date || null;
      this.payload.cash_commitment = this.payload.cash_commitment || 0;
      this.payload.default_currency_id = this.defaultCurrencyId;
      if (!this.validateForm(false)) {
        return this.toast('Please populate all required fields', 'pink');
      }
      if (this.payload.inactive_date && new Date(this.payload.inactive_date) > new Date()) {
        return this.toast('Cannot enter an Inactive Date in the future', 'pink');
      }
      if (this.payload.inactive_date && new Date(this.payload.active_date) > new Date(this.payload.inactive_date)) {
        return this.toast('Inactive Date cannot be earlier than Active Date', 'pink');
      }
      const { data } = await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio/`, this.payload);
      this.notificationMessage = `Saved ${this.payload.name} (${this.payload.slug}). Service_id: ${this.payload.service_id} Portfolio_id: ${data.portfolio.id}`;
      this.openNotificationModal();
      this.payload = { ...defaultPayload };
      this.resetForm();
    },
    async sendPortfolioRequest() {
      this.payload.inactive_date = this.payload.inactive_date || null;
      this.payload.analyst_id = this.$auth.user.pk;
      this.payload.name = this.payload.name.trim();
      this.payload.slug = this.payload.slug.trim();
      this.payload.active = !this.payload.inactive_date;
      this.payload.cash_commitment = this.payload.cash_commitment || 0;

      if (!this.validateForm(true)) {
        return this.toast('Please populate all required fields', 'pink');
      }
      if (this.payload.inactive_date && new Date(this.payload.inactive_date) > new Date()) {
        return this.toast('Cannot enter an Inactive Date in the future', 'pink');
      }
      if (this.payload.inactive_date && new Date(this.payload.active_date) > new Date(this.payload.inactive_date)) {
        return this.toast('Inactive Date cannot be earlier than Active Date', 'pink');
      }

      const userName = this.$auth.user.name;
      const portfolioName = this.payload.name;
      const serviceId = this.payload.service_id;
      const portfolioRequestMessage = `${userName} is requesting to add a Portfolio:
        Name: ${portfolioName}
        Slug: ${this.payload.slug}
        Service Name: ${this.service_name}
        Active Date: ${this.payload.active_date}
        Inactive Date: ${this.payload.inactive_date}
        Default Currency Name: ${this.defaultCurrencyName}
        Cash Commitment: ${this.payload.cash_commitment}
        Embargo Recs Until Publish: ${this.payload.embargo_recs_until_publish}
      `;
      const payload = { message: portfolioRequestMessage, channel: window.env.SLACK_HELP_CHANNEL };
      this.payload = { ...defaultPayload };
      await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/common/slack/`, payload);
      let thankYouMessage = `Thanks! Your request to add the portfolio: ${portfolioName} has been submitted to the Investing Services team.`;
      if (serviceId === 0) {
        thankYouMessage = `${thankYouMessage} NOTE: It appears you've requested a portfolio without a service. If this wasn't intentional, please send a request to <a href="/tickeradmin/addservice">add a service.</a>`;
      }
      this.notificationMessage = thankYouMessage;
      this.openNotificationModal();
      this.resetForm();
    },
    resetForm() {
      document.getElementById('ticker-admin-add-portfolio-service').value = '';
      document.getElementById('ticker-admin-add-portfolio-active-date').value = '';
      document.getElementById('ticker-admin-add-portfolio-inactive-date').value = '';
      document.getElementById('add-portfolio-benchmark-autocomplete').value = '';
      const timezoneInput = document.getElementById('add-portfolio-timezone-autocomplete');
      if (timezoneInput) {
        timezoneInput.value = ''
      }
    },
  },
  mounted() {
    this.fetchMetadata();
    this.initDatepicker();
    this.fetchPortfolioTimezones();
  },
};
</script>
